'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Table.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Table formatting for wrapping thead/tbody
 */
var Table = function Table(_ref) {
  var bordered = _ref.bordered,
    nowrap = _ref.nowrap,
    alignMiddle = _ref.alignMiddle,
    striped = _ref.striped,
    noMargin = _ref.noMargin,
    horizontal = _ref.horizontal,
    selectable = _ref.selectable,
    children = _ref.children;
  var baseTableClass = (0, _classnames2.default)('c-table', {
    'c-table--bordered': bordered
  }, {
    'c-table--nowrap': nowrap
  }, {
    'c-table--align-middle': alignMiddle
  }, {
    'c-table--striped': striped
  }, {
    'c-table--no-margin': noMargin
  }, {
    'c-table--horizontal': horizontal
  }, {
    'js-data-table--singular-action': selectable
  });
  return _react2.default.createElement('table', {
    className: baseTableClass
  }, children);
};
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Sets a border around the table */
  bordered: _propTypes2.default.bool,
  /** Will not wrap content if set */
  nowrap: _propTypes2.default.bool,
  /** Sets vertical alignment to middle */
  alignMiddle: _propTypes2.default.bool,
  /** Sets background of very other element so it looks like stripes */
  striped: _propTypes2.default.bool,
  /** Removes the margin */
  noMargin: _propTypes2.default.bool,
  /** Makes the table horizontal with a fixed width */
  horizontal: _propTypes2.default.bool,
  /** Makes the table selectable */
  selectable: _propTypes2.default.bool,
  /** Children to display within the table */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};
exports.default = Table;